<template>
  <a-row
    :gutter="32"
  >
      <a-col :xs="24" :sm="24" :md="10" :lg="7" >
        <div class="files-filter-form-container">
            <slot name="search-form"></slot>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="14" :lg="17" >
        <slot name="search-order"></slot>
        <slot name="pagination-top"></slot>
        <div class="files-filter-results-container">
          <slot name="search-results"></slot>
        </div>
        <slot name="pagination-bottom"></slot>
      </a-col>
  </a-row>
</template>

<script>

export default {

    components: {
    },

    data() {
        return {

        }
    },

    computed: {
    }
}
</script>

<style lang="scss" scoped>
    .files-filter-form-container {
        border: 1px solid $primary-blue;
        border-radius: 5px;
        padding:20px;
    }
</style>